import { color, extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    head: "Montserrat",
    subhead: "Poppins",
    content: "Syne",
  },
  colors: {
    lgrey: "#718096"
  },
});

export default theme;